/* <script src="//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"></script> */

<template>
  <div>
    <h3>Postcode Sample</h3>
    <h5>우편번호: <input type="text" v-model="postcode"> <!-- <span>{{ zip }}</span> --></h5> 
    <h5>기본주소: <input type="text" v-model="addr1"></h5> 
    <h5>상세주소: <input type="text" v-model="addr2"></h5> 
    <button @click="showAddress">주소API 호출</button>
  </div>
</template>

<script>
import * as addressFind from '@/utils/addressFind'

export default {
  components:{
   
  },
  data() {
    return {
     postcode: '', 
     addr1: '', 
     addr2: ''
    }
  },
  computed: {
   
  },
  methods:{
    showAddress() { 
      addressFind.FindAddress(this);
    },
  }
}
</script>